import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=1568f26a&scoped=true"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568f26a",
  null
  
)

export default component.exports